import { Form, Select, Input, DatePicker, Spin, Alert, Button, Icon } from 'antd';
import moment from 'moment';
import React from 'react';
import Swal from 'sweetalert2';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { FormComponentProps } from 'antd/lib/form/Form';
import { TitledContainer } from '../../../components/TitledContainer/TitledContainer';
import { getDriver } from '../../../core-module/redux/Auth/actions';
import { loopBackApi } from '../../../core-module/models/LoopBack/Api/LoopBackApi';

interface OwnProps {
  dispatch: Dispatch;
}

interface State {
  loading: boolean;
}

type Props = OwnProps & FormComponentProps & ReturnType<typeof mapPropsToDispatch>;

class Profile extends React.Component<Props, State> {

  constructor(props) {
    super(props);

    this.state = {
      loading: false
    };
  }
  componentDidMount() {
    document.title = 'Logistics | Profiel';

    this.props.dispatch(getDriver());
  }

  handleSubmit = () => {
    const vehicle_num_of_bags = this.props.form.getFieldValue('vehicle_num_of_bags');
    if(vehicle_num_of_bags) {
      const number = parseInt(vehicle_num_of_bags, 10);
      if(!isNaN(number)) {
        this.setState({ loading: true });
        loopBackApi()
          .patch(`drivers/by-user`, { vehicle_num_of_bags: vehicle_num_of_bags })
          .then(() => {
            this.setState({ loading: false });
            Swal({
              title: 'Profiel',
              text: `Je gegevens is succesvol aangepast`,
              type: 'success',
              confirmButtonText: 'Ok'
            }).then((result) => {
              this.props.dispatch(getDriver());
            });
          })
          .catch(() => {
            this.setState({ loading: false });
            Swal({
              title: 'Helaas',
              text: `Er is iets mis gegaan bij het opslaan van het profiel`,
              type: 'error',
              confirmButtonText: 'Ok'
            });
          });
      } else {
        Swal({
          title: 'Helaas',
          text: `Er is iets mis gegaan bij het opslaan van het profiel`,
          type: 'error',
          confirmButtonText: 'Ok'
        });
      }
    } else {
      Swal({
        title: 'Helaas',
        text: `Er is iets mis gegaan bij het opslaan van het profiel`,
        type: 'error',
        confirmButtonText: 'Ok'
      });
    }
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      style: { marginTop: 20 },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 10 }
      }
    };   

    let driver = this.props.auth.user.driver;

    return (
      <TitledContainer title='Profiel'>
        <Spin spinning={this.props.auth.loading} delay={500}>
          <Alert
            type='info'
            message='Neem contact op met logistiek@uitgekookt.nl indien je de profielgegevens wilt wijzigen.'
          />
          <Form {...formItemLayout}>
            <h4>Persoons gegevens</h4>
            <hr />
            <Form.Item label='Voorletters'>
              {getFieldDecorator('initials', {
                rules: [{ required: true, message: 'Voer de voorletters in' }],
                initialValue: driver!.initials
              })(<Input disabled />)}
            </Form.Item>
            <Form.Item label='Voornaam'>
              {getFieldDecorator('first_name', {
                rules: [{ required: true, message: 'Voer de voornaam in' }],
                initialValue: driver!.first_name
              })(<Input disabled />)}
            </Form.Item>
            <Form.Item label='Voorvoegsels'>
              {getFieldDecorator('insertions', {
                rules: [{ required: false }],
                initialValue: driver!.insertions
              })(<Input disabled />)}
            </Form.Item>
            <Form.Item label='Achternaam'>
              {getFieldDecorator('last_name', {
                rules: [{ required: true, message: 'Voer de achternaam in' }],
                initialValue: driver!.last_name
              })(<Input disabled />)}
            </Form.Item>
            <Form.Item label='Geboortedatum'>
              {getFieldDecorator('date_of_birth', {
                rules: [{ required: true, message: 'Voer je geboortedatum in' }],
                initialValue: moment(driver!.date_of_birth)
              })(<DatePicker format='DD-MM-YYYY' disabled />)}
            </Form.Item>
            <Form.Item label='Geslacht'>
              {getFieldDecorator('gender', {
                rules: [{ required: true, message: 'Maak een keuze' }],
                initialValue: driver!.gender
              })(
                <Select style={{ width: '100%' }} placeholder='- Maak een keuze -' disabled>
                  <Select.Option value='male'>Man</Select.Option>
                  <Select.Option value='female'>Vrouw</Select.Option>
                </Select>
              )}
            </Form.Item>
            <Form.Item label='Telefoon'>
              {getFieldDecorator('phone', {
                rules: [{ required: false, message: 'Voer een telefoonnummer in' }],
                initialValue: driver!.phone
              })(<Input disabled />)}
            </Form.Item>
            <Form.Item label='Mobiel - Primair'>
              {getFieldDecorator('mobile', {
                rules: [{ required: false, message: 'Voer een mobiele telefoonnummer in' }],
                initialValue: driver!.mobile
              })(<Input disabled />)}
            </Form.Item>
            <Form.Item label='Mobiel - Secundair'>
              {getFieldDecorator('mobile_2', {
                rules: [{ required: false, message: 'Voer een mobiele telefoonnummer in' }],
                initialValue: driver!.mobile_2
              })(<Input disabled />)}
            </Form.Item>
            <Form.Item label='Email'>
              {getFieldDecorator('email', {
                rules: [{ required: true, message: 'Voer een email adres in' }],
                initialValue: driver!.email
              })(<Input disabled />)}
            </Form.Item>
            <h4>Adres gegevens</h4>
            <hr />
            <Form.Item label='Postcode'>
              {getFieldDecorator('postal_code', {
                rules: [{ required: true, message: 'Voer een postcode in' }],
                initialValue: driver!.postal_code
              })(<Input disabled />)}
            </Form.Item>
            <Form.Item label='Huisnummer'>
              {getFieldDecorator('door_number', {
                rules: [{ required: true, message: 'Voer een huisnummer in' }],
                initialValue: driver!.door_number
              })(<Input disabled />)}
            </Form.Item>
            <Form.Item label='Straat'>
              {getFieldDecorator('street_name', {
                rules: [
                  {
                    required: true,
                    message: 'Voer een geldige postcode en huisnummer combinatie in'
                  }
                ],
                initialValue: driver!.street_name
              })(<Input disabled />)}
            </Form.Item>
            <Form.Item label='Stad'>
              {getFieldDecorator('city', {
                rules: [
                  {
                    required: true,
                    message: 'Voer een geldige postcode en huisnummer combinatie in'
                  }
                ],
                initialValue: driver!.city
              })(<Input disabled />)}
            </Form.Item>

            <h4>Administratieve gegevens</h4>
            <hr />
            <Form.Item label='Burgerservicenummer'>
              {getFieldDecorator('bsn', {
                rules: [{ required: true, message: 'Voer het BSN in' }],
                initialValue: driver!.bsn
              })(<Input disabled />)}
            </Form.Item>
            <Form.Item label='IBAN'>
              {getFieldDecorator('iban', {
                rules: [{ required: true, message: 'Voer een IBAN in' }],
                initialValue: driver!.iban
              })(<Input disabled />)}
            </Form.Item>
            <Form.Item label='Bank'>
              {getFieldDecorator('bank', {
                rules: [{ required: true, message: 'Maak een keuze' }],
                initialValue: driver!.bank
              })(
                <Select style={{ width: '100%' }} placeholder='- Maak een keuze -' disabled>
                  <Select.Option value='ABNANL2A'>ABN Amro</Select.Option>
                  <Select.Option value='AEGONL2U'>Aegon bank</Select.Option>
                  <Select.Option value='ANAANL21'>Allianz Nederland Asset Management</Select.Option>
                  <Select.Option value='ANDLNL2A'>Anadolubank</Select.Option>
                  <Select.Option value='ARBNNL22'>Achmea Bank</Select.Option>
                  <Select.Option value='ARSNNL21'>Argenta Spaarbank</Select.Option>
                  <Select.Option value='ARTENL2A'>GE Artesia Bank</Select.Option>
                  <Select.Option value='ASNBNL21'>ASN BANK</Select.Option>
                  <Select.Option value='ASRBNL2R'>ASR BANK</Select.Option>
                  <Select.Option value='ATBANL2A'>Amsterdam Trade Bank</Select.Option>
                  <Select.Option value='BBRUNL2X'>ING Belgie</Select.Option>
                  <Select.Option value='BCDMNL22'>Banque Chaabi Du Maroc</Select.Option>
                  <Select.Option value='BCITNL2A'>Intesa Sanpaolo</Select.Option>
                  <Select.Option value='BICKNL2A'>BinckBank</Select.Option>
                  <Select.Option value='BKCHNL2R'>Bank of China</Select.Option>
                  <Select.Option value='BKMGNL2A'>Bank Mendes Gans</Select.Option>
                  <Select.Option value='BMEUNL21'>Bmce Euroservice</Select.Option>
                  <Select.Option value='BNGHNL2G'>Bank Nederlandse Gemeenten (BNG)</Select.Option>
                  <Select.Option value='BNPANL2A'>BNP Paribas Fortis</Select.Option>
                  <Select.Option value='BOFANLNX'>Bank of America</Select.Option>
                  <Select.Option value='BOFSNL21002'>Bank of Scotland, Amsterdam</Select.Option>
                  <Select.Option value='BUNQNL2A'>bunq</Select.Option>
                  <Select.Option value='CEBUNL2U'>C E Bankiers</Select.Option>
                  <Select.Option value='CITINL2X'>Citybank International</Select.Option>
                  <Select.Option value='CHASNL2X'>JPMorgan Chase</Select.Option>
                  <Select.Option value='CITCNL2A'>Citco Bank Nederland </Select.Option>
                  <Select.Option value='COBANL2X'>Commerzbank</Select.Option>
                  <Select.Option value='DEUTNL2N'>Deutsche Bank</Select.Option>
                  <Select.Option value='DHBNNL2R'>Demir-Halk Bank </Select.Option>
                  <Select.Option value='DLBKNL2A'>Delta Lloyd Bank</Select.Option>
                  <Select.Option value='FVLBNL22'>F. van Lanshot Bankiers</Select.Option>
                  <Select.Option value='DNIBNL2G'>NIBC Bank</Select.Option>
                  <Select.Option value='FBHLNL2A'>Credit Europe Bank</Select.Option>
                  <Select.Option value='FLORNL2A'>De Nederlandsche Bank</Select.Option>
                  <Select.Option value='FRBKNL2L'>Friesland Bank</Select.Option>
                  <Select.Option value='FRGHNL21'>FGH Bank</Select.Option>
                  <Select.Option value='GILLNL2A'>Theodoor Gilissen Bankiers</Select.Option>
                  <Select.Option value='HANDNL2A'>Svenska Handelsbanken AB</Select.Option>
                  <Select.Option value='HHBANL22'>Hof Hoorneman Bankiers</Select.Option>
                  <Select.Option value='HSBCNL2A'>HSBC BANK</Select.Option>
                  <Select.Option value='ICBKNL2A'>
                    Industrial and Commercial Bank of China
                  </Select.Option>
                  <Select.Option value='INGBNL2A'>ING bank</Select.Option>
                  <Select.Option value='INSINL2A'>Insinger de Beaufort</Select.Option>
                  <Select.Option value='KABANL2A'>Yapi Kredi Bank</Select.Option>
                  <Select.Option value='KASANL2A'>KAS BANK</Select.Option>
                  <Select.Option value='KNABNL2H'>KNAB</Select.Option>
                  <Select.Option value='KOEXNL2A'>Korea Exchange Bank</Select.Option>
                  <Select.Option value='KREDNL2X'>KBC Bank</Select.Option>
                  <Select.Option value='LOYDNL2A'>Lloyds Bank</Select.Option>
                  <Select.Option value='LPLNNL2F'>LeasePlan Corporation</Select.Option>
                  <Select.Option value='MHCBNL2A'>Mizuho Corporate Bank</Select.Option>
                  <Select.Option value='NNBANL2G'>Nationale-Nederlanden Bank</Select.Option>
                  <Select.Option value='NWABNL2G'>Nederlandse Waterschapsbank</Select.Option>
                  <Select.Option value='OVBNNL22'>Levob Bank</Select.Option>
                  <Select.Option value='RABONL2U'>Rabobank</Select.Option>
                  <Select.Option value='RBOSNL2A'>Royal Bank of Scotland</Select.Option>
                  <Select.Option value='RBRBNL21'>RegioBank</Select.Option>
                  <Select.Option value='SNSBNL2A'>SNS Bank</Select.Option>
                  <Select.Option value='STALNL2G'>Staalbankiers</Select.Option>
                  <Select.Option value='TRIONL2U'>Triodos Bank</Select.Option>
                  <Select.Option value='UGBINL2A'>Garantibank</Select.Option>
                  <Select.Option value='VOWANL21'>Volkswagen Bank</Select.Option>
                  <Select.Option value='ZWLBNL21'>ZwitserlevenBank</Select.Option>
                </Select>
              )}
            </Form.Item>

            <h4>Details tweede rekening</h4>
            <hr />

            <Form.Item label='Voorletters'>
              {getFieldDecorator('second_initials', {
                rules: [{ required: false, message: 'Voer de voorletters in' }],
                initialValue: driver!.second_initials
              })(<Input disabled />)}
            </Form.Item>
            <Form.Item label='Voornaam'>
              {getFieldDecorator('second_first_name', {
                rules: [{ required: false, message: 'Voer de voornaam in' }],
                initialValue: driver!.second_first_name
              })(<Input disabled />)}
            </Form.Item>
            <Form.Item label='Voorvoegsels'>
              {getFieldDecorator('second_insertions', {
                rules: [{ required: false, message: 'Voer de voorvoegsels in' }],
                initialValue: driver!.second_insertions
              })(<Input disabled />)}
            </Form.Item>
            <Form.Item label='Achternaam'>
              {getFieldDecorator('second_last_name', {
                rules: [{ required: false, message: 'Voer de achternaam in' }],
                initialValue: driver!.second_last_name
              })(<Input disabled />)}
            </Form.Item>
            <Form.Item label='Postcode'>
              {getFieldDecorator('second_postal_code', {
                rules: [{ required: false, message: 'Voer een postcode in' }],
                initialValue: driver!.second_postal_code
              })(<Input disabled />)}
            </Form.Item>
            <Form.Item label='Huisnummer'>
              {getFieldDecorator('second_door_number', {
                rules: [{ required: false, message: 'Voer een huisnummer in' }],
                initialValue: driver!.second_door_number
              })(<Input disabled />)}
            </Form.Item>
            <Form.Item label='Straat'>
              {getFieldDecorator('second_street_name', {
                rules: [
                  {
                    required: false,
                    message: 'Voer een geldige postcode en huisnummer combinatie in'
                  }
                ],
                initialValue: driver!.second_street_name
              })(<Input disabled />)}
            </Form.Item>
            <Form.Item label='Stad'>
              {getFieldDecorator('second_city', {
                rules: [
                  {
                    required: false,
                    message: 'Voer een geldige postcode en huisnummer combinatie in'
                  }
                ],
                initialValue: driver!.second_city
              })(<Input disabled />)}
            </Form.Item>
            <Form.Item label='IBAN'>
              {getFieldDecorator('second_iban', {
                rules: [{ required: false, message: 'Voer een IBAN in' }],
                initialValue: driver!.second_iban
              })(<Input disabled />)}
            </Form.Item>
            <Form.Item label='Bank'>
              {getFieldDecorator('second_bank', {
                rules: [{ required: false, message: 'Maak een keuze' }],
                initialValue: driver!.second_bank
              })(
                <Select style={{ width: '100%' }} placeholder='- Maak een keuze -' disabled>
                  <Select.Option value='ABNANL2A'>ABN Amro</Select.Option>
                  <Select.Option value='AEGONL2U'>Aegon bank</Select.Option>
                  <Select.Option value='ANAANL21'>Allianz Nederland Asset Management</Select.Option>
                  <Select.Option value='ANDLNL2A'>Anadolubank</Select.Option>
                  <Select.Option value='ARBNNL22'>Achmea Bank</Select.Option>
                  <Select.Option value='ARSNNL21'>Argenta Spaarbank</Select.Option>
                  <Select.Option value='ARTENL2A'>GE Artesia Bank</Select.Option>
                  <Select.Option value='ASNBNL21'>ASN BANK</Select.Option>
                  <Select.Option value='ASRBNL2R'>ASR BANK</Select.Option>
                  <Select.Option value='ATBANL2A'>Amsterdam Trade Bank</Select.Option>
                  <Select.Option value='BBRUNL2X'>ING Belgie</Select.Option>
                  <Select.Option value='BCDMNL22'>Banque Chaabi Du Maroc</Select.Option>
                  <Select.Option value='BCITNL2A'>Intesa Sanpaolo</Select.Option>
                  <Select.Option value='BICKNL2A'>BinckBank</Select.Option>
                  <Select.Option value='BKCHNL2R'>Bank of China</Select.Option>
                  <Select.Option value='BKMGNL2A'>Bank Mendes Gans</Select.Option>
                  <Select.Option value='BMEUNL21'>Bmce Euroservice</Select.Option>
                  <Select.Option value='BNGHNL2G'>Bank Nederlandse Gemeenten (BNG)</Select.Option>
                  <Select.Option value='BNPANL2A'>BNP Paribas Fortis</Select.Option>
                  <Select.Option value='BOFANLNX'>Bank of America</Select.Option>
                  <Select.Option value='BOFSNL21002'>Bank of Scotland, Amsterdam</Select.Option>
                  <Select.Option value='BUNQNL2A'>bunq</Select.Option>
                  <Select.Option value='CEBUNL2U'>C E Bankiers</Select.Option>
                  <Select.Option value='CITINL2X'>Citybank International</Select.Option>
                  <Select.Option value='CHASNL2X'>JPMorgan Chase</Select.Option>
                  <Select.Option value='CITCNL2A'>Citco Bank Nederland </Select.Option>
                  <Select.Option value='COBANL2X'>Commerzbank</Select.Option>
                  <Select.Option value='DEUTNL2N'>Deutsche Bank</Select.Option>
                  <Select.Option value='DHBNNL2R'>Demir-Halk Bank </Select.Option>
                  <Select.Option value='DLBKNL2A'>Delta Lloyd Bank</Select.Option>
                  <Select.Option value='FVLBNL22'>F. van Lanshot Bankiers</Select.Option>
                  <Select.Option value='DNIBNL2G'>NIBC Bank</Select.Option>
                  <Select.Option value='FBHLNL2A'>Credit Europe Bank</Select.Option>
                  <Select.Option value='FLORNL2A'>De Nederlandsche Bank</Select.Option>
                  <Select.Option value='FRBKNL2L'>Friesland Bank</Select.Option>
                  <Select.Option value='FRGHNL21'>FGH Bank</Select.Option>
                  <Select.Option value='GILLNL2A'>Theodoor Gilissen Bankiers</Select.Option>
                  <Select.Option value='HANDNL2A'>Svenska Handelsbanken AB</Select.Option>
                  <Select.Option value='HHBANL22'>Hof Hoorneman Bankiers</Select.Option>
                  <Select.Option value='HSBCNL2A'>HSBC BANK</Select.Option>
                  <Select.Option value='ICBKNL2A'>
                    Industrial and Commercial Bank of China
                  </Select.Option>
                  <Select.Option value='INGBNL2A'>ING bank</Select.Option>
                  <Select.Option value='INSINL2A'>Insinger de Beaufort</Select.Option>
                  <Select.Option value='KABANL2A'>Yapi Kredi Bank</Select.Option>
                  <Select.Option value='KASANL2A'>KAS BANK</Select.Option>
                  <Select.Option value='KNABNL2H'>KNAB</Select.Option>
                  <Select.Option value='KOEXNL2A'>Korea Exchange Bank</Select.Option>
                  <Select.Option value='KREDNL2X'>KBC Bank</Select.Option>
                  <Select.Option value='LOYDNL2A'>Lloyds Bank</Select.Option>
                  <Select.Option value='LPLNNL2F'>LeasePlan Corporation</Select.Option>
                  <Select.Option value='MHCBNL2A'>Mizuho Corporate Bank</Select.Option>
                  <Select.Option value='NNBANL2G'>Nationale-Nederlanden Bank</Select.Option>
                  <Select.Option value='NWABNL2G'>Nederlandse Waterschapsbank</Select.Option>
                  <Select.Option value='OVBNNL22'>Levob Bank</Select.Option>
                  <Select.Option value='RABONL2U'>Rabobank</Select.Option>
                  <Select.Option value='RBOSNL2A'>Royal Bank of Scotland</Select.Option>
                  <Select.Option value='RBRBNL21'>RegioBank</Select.Option>
                  <Select.Option value='SNSBNL2A'>SNS Bank</Select.Option>
                  <Select.Option value='STALNL2G'>Staalbankiers</Select.Option>
                  <Select.Option value='TRIONL2U'>Triodos Bank</Select.Option>
                  <Select.Option value='UGBINL2A'>Garantibank</Select.Option>
                  <Select.Option value='VOWANL21'>Volkswagen Bank</Select.Option>
                  <Select.Option value='ZWLBNL21'>ZwitserlevenBank</Select.Option>
                </Select>
              )}
            </Form.Item>
            <h4>Rijgegevens</h4>
            <hr />
            <Form.Item label='Maximaal aantal tassen'>
              {getFieldDecorator('vehicle_num_of_bags', {
                rules: [{ message: 'Voer het maximaal aantal tassen van je auto/bus in' }],
                initialValue: driver!.vehicle_num_of_bags
              })(<Input />)}
            </Form.Item>
            <Button
              htmlType='button'
              type='primary'
              className='login-form-button'
              onClick={this.handleSubmit}
            >
              {this.state.loading && (
                <Icon type='loading' style={{ fontSize: 24, color: 'white' }} spin />
              )}
              Opslaan
            </Button>
          </Form>
        </Spin>
      </TitledContainer>
    );
  }
}

const mapPropsToDispatch = (appState) => ({ auth: appState.auth });

export default connect(mapPropsToDispatch)(Form.create()(Profile));
